import React from "react";

import { Typography, Stack, Chip, Divider } from "@mui/material";

import Panel, { PanelProps } from "../Panel/panel";
import PanelHeader from "../PanelHeader/panel-header";
import { Distinct } from "../../../Utils/helpers";
import { useTranslation } from "react-i18next";

export interface CastingPanelProps extends PanelProps {
  cast: { [key: string]: string[] };
}

const CastingPanel: React.FC<CastingPanelProps> = ({ cast, open, onClose, ...otherProps }) => {
  const { t } = useTranslation();
  return (
    <Panel
      anchor="right"
      header={<PanelHeader onClose={onClose as () => void} title={t("common:castAndCrew")} />}
      open={open}
      onClose={onClose}
      {...otherProps}
    >
      {Object.keys(cast).map((key) => (
        <React.Fragment key={key}>
          <Stack direction="row" mb={1.5} mt={2.5}>
            <Typography variant="subtitle2" fontWeight={600} flex={1}>
              {key}
            </Typography>
            <Stack direction="row" justifyContent="flex-end" flexWrap="wrap" flex={1}>
              {cast[key].filter(Distinct).map((item) => (
                <Chip label={item} key={item} size="small" sx={{ mb: 1, mr: 1 }} />
              ))}
            </Stack>
          </Stack>
          <Divider />
        </React.Fragment>
      ))}
    </Panel>
  );
};

export default CastingPanel;
